import { useContext } from 'react';
import { ConfigContext } from '../components/ConfigProvider/ConfigContext';

export const useConfig = () => useContext(ConfigContext);
